import { FC, ReactNode } from "react"

interface StepActionBarProps {
  children: ReactNode
}

/**
 * Fixed-bottom action bar shared by the upload-timesheet steps. Mirrors the
 * pattern in src/pages/dashboard/performance/setup/SetupWrapper.tsx so the
 * primary step action (Next / Submit) is always anchored to the viewport.
 *
 * `md:left-[var(--sidenav-w)] transition-[left] duration-300 ease-in-out motion-reduce:transition-none` clears the main app navigation sidebar on md+ screens.
 */
const StepActionBar: FC<StepActionBarProps> = ({ children }) => (
  <div className="fixed bottom-0 right-0 left-0 md:left-[var(--sidenav-w)] transition-[left] duration-300 ease-in-out motion-reduce:transition-none py-4 px-4 md:px-6 lg:px-10 border-t border-[#E2E8F0] bg-white z-10">
    <div className="flex justify-end gap-4">{children}</div>
  </div>
)

export default StepActionBar
